import ApplicationController from './application_controller'

// A frame that fails to load keeps whatever it was showing, so a dead
// connection left the panel reading "Loading" for ever, indistinguishable from
// a slow one. Turbo fires turbo:fetch-request-error on the frame when the
// request itself fails; offline is the common case.
//
// The controller sits on the panel, not on the frame: Turbo rewrites the
// frame's own attributes from the response, and the controller would go with
// them. The event bubbles, so listening one level up catches it either way.
export default class SlaModuleController extends ApplicationController {
  static targets = ['frame']

  connect () {
    this.onError = (event) => {
      event.preventDefault()
      this.showFailure()
    }
    this.element.addEventListener('turbo:fetch-request-error', this.onError)
  }

  disconnect () {
    this.element.removeEventListener('turbo:fetch-request-error', this.onError)
  }

  // Inside the card's body, so the card and its title stay on screen. Written
  // over the whole frame, the error and its button stood alone outside any
  // card (staging QA, 28/09).
  showFailure () {
    this.frameTarget.querySelector('.sla-card__body').innerHTML = `
      <p class="sla-module__error">${this.element.dataset.slaModuleErrorMessage}</p>
      <button type="button" class="button" data-action="sla-module#retry">
        ${this.element.dataset.slaModuleRetryLabel}
      </button>`
  }

  // Turbo reloads a lazy frame only once it has loaded: after a failed first
  // load, reload() did nothing and Retry stayed dead once back online. Turning
  // the frame eager loads it now; from then on reload() works.
  retry () {
    if (this.frameTarget.loading === 'lazy') {
      this.frameTarget.loading = 'eager'
    } else {
      this.frameTarget.reload()
    }
  }
}
